<template>
  <fragment>
    <div class="row" v-if="entity">
      <div class="col-12">
        <div class="card m-b-30">
          <div class="card-body">
            <div class="tab-content" id="v-pills-product-tabContent">
              <div
                class="tab-pane fade show active"
                id="v-pills-general"
                role="tabpanel"
                aria-labelledby="v-pills-general-tab"
              >
                <!-- generale -->
                <div id="baseinformation" v-if="entity">
                  

                  <div class="row">

                   
                          <div class="col-12">
                      <div class="form-group">
                        <ValidationProvider
                          v-slot="{ classes, errors }"
                          immediate
                          slim
                          rules="required"
                        >
                          <label class="col-form-label" for="lastName"
                            >Nome profilo</label
                          >
                          <input
                            type="text"
                            class="form-control required"
                            :readonly="!$store.getters.isInRole('profile-edit')"
                            id="name"
                            name="name"
                            placeholder="Nome"
                            v-model="entity.name"
                            :class="classes"
                           
                          />
                        </ValidationProvider>
                      </div>
                    </div>
                   
     <div class="col-12" v-for="s,index in canDos" v-bin:key="index" >
                     <h4 class="page-title">{{index}}</h4>
                     <div class="row">
 <div class="col-12 ml-3" v-for="profile in s">
                      <div
                        class="custom-control custom-checkbox custom-control-inline"
                       >
                        <input
                         
                          :value="profile.canDoId"
                          type="checkbox"
                          :id="profile.canDoId"
                         
                          class="custom-control-input"
                           v-model="selectedProfiles"
                        />
                        <label class="custom-control-label" :for="profile.canDoId"
                          >{{profile.description}}</label
                        >
                      </div>
                   
                    </div>
                     </div>
                     </div>
                
                  </div>

                  <div class="row">
                    <div class="col-12">
                    <div class="form-group mt-3">
                      <button
                        type="button"
                        class="btn btn-xs btn-primary-rgba mr-2"
                        v-on:click="save"
                      >
                        Salva
                        <font-awesome-icon
                          :icon="['far', 'save']"
                        ></font-awesome-icon>
                      </button>
                      <button
                        type="button"
                        class="btn btn-xs btn-danger-rgba mr-2"
                        v-on:click="cancel"
                      >
                        Annulla
                        <font-awesome-icon
                          :icon="['far', 'times-circle']"
                        ></font-awesome-icon>
                      </button>
                    </div>
                    </div>
                    <!--</form>-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </fragment>
</template>

<script>
import Editor from "@tinymce/tinymce-vue";
import axios from "axios";
import { Chrome } from "vue-color";
import { Slider } from "vue-color";
export default {
  data() {
    return {
      entity: null,
      profiles:[],
      canDos:null,
      selectedProfiles:[]
    };
  },
  computed: {
   
   
  },
  components: {
    Editor,
    "chrome-picker": Chrome,
  },
  name: "ProfileSave",
  mounted() {
    setTimeout(this.loadData(),500);
  },
  methods: {
    loadData(){

      var me = this;
  
    axios
      .get(
        "user/profile/" + (me.$route.params.id || "new")
      )
      .then((response) => {
        me.entity = response.data;
        me.selectedProfiles = me.entity.canDo.split(';');
        if (me.entity.firstName != "")
          me.$store.state.breadCrump.title = me.entity.name;

setTimeout(me.loadCanDo(),200);


      });
    },
    cancel() {
      this.$router.push({
        name: "route-profile-list",

        replace: true,
      });
    },
   loadCanDo(){
  var me = this;
     axios
      .get(
        "user/cando"
      )
      .then((r) => {

       me.canDos ={};
        me.profiles = r.data;
       for(var i=0; i< r.data.length; i++ ){
         var section = r.data[i].section.toLowerCase();
         if(section=="") section="admin";
          console.log(me.canDos[section], section);
         if(!me.canDos[section] ){
         me.canDos[section] =[];
         }
          me.canDos[section].push(r.data[i]);
console.log(me.canDos)
      }
      });
   },
    updateFromPicker(color) {
      this.entity.backgroundColor = color.hex;
    },
    save() {
      let me = this;

      

          me.entity.canDo = me.selectedProfiles.join(';');
      axios.post("user/profile/save", this.entity).then((response) => {
        if (me.$route.params.id != response.data.userId) {
          me.$router.push({
            name: "route-profile-edit",
            params: { id: response.data.userId },
          });
        }

        me.$swal({
          title: "Salvataggio avvenuto correttamente",
          text: "",
          type: "success",
          showCancelButton: false,
          toast: true,
          timer: 2000,
          showConfirmButton: false,
          position: "bottom-top",
        });
      });

        
      


    },
  },
};
</script>
